import { render } from "./Dropdown.vue?vue&type=template&id=72b5dcae&scoped=true&ts=true"
import script from "./Dropdown.vue?vue&type=script&lang=ts"
export * from "./Dropdown.vue?vue&type=script&lang=ts"

import "./Dropdown.vue?vue&type=style&index=0&id=72b5dcae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b5dcae"]])

export default __exports__